import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap } from '@angular/router';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { BillerDashboardService } from '../../biller-dashboard.service';
import * as global from '../../../global';
import { ToastrService } from 'ngx-toastr';
import {BILLING_COMPANIES as BillingCompaniesConstants} from 'src/app/constants/billing_companies_constants';

@Component({
  selector: 'app-audit-popup',
  templateUrl: './audit-popup.component.html',
  styleUrls: ['./audit-popup.component.css']
})
export class AuditPopupComponent implements OnInit {
  charge_id;
  auditData;
  loading = true;
  hasData = true;
  creationData ={
    action: "",
    date:  null, 
    performer: ""
  };
  operations = []; 
  highestLengt;
  displayColumns = ['creationDate', 'updationDate', 'submissonDate', 'resubmissionDate', 'actionFrom', ]
  constructor(
    public billerDashboardService: BillerDashboardService,
    private _route: ActivatedRoute,
    public _authService: AuthService,
    private _toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    // console.log("this.data--------: ", this.data)
    this.charge_id = this.data;
    // this.patientData = this.data.patient; 
    this.getChargeAudit();
  }
  getAuditData(audit) { 
    const operationMap = {
        'create': 'Created',
        'update': 'Updated',
        'submit': 'Submitted',
        'resubmit': 'Resubmitted',
        'billed': 'Billed',
        'coded': 'Coded',
        'unbillable': 'Unbillable',
        'opm': 'Data sent to OPM',
        'care_cloud': 'Data sent to Care Cloud',
        'parp': 'Data sent to PARP',
        'hp': 'Data sent to HP',
        'simplibill-telos': 'Data sent to SimpliBill-Telos',
        'simplibill-applebaum': 'Data sent to SimpliBill-Applebaum',
        'opm-adt': 'Data sent to OPM-ADT',
        'shifox': 'Data sent to ShiFox',
        'cmd-adt': 'ADT data sent to CMD',
        'cmd-dft': 'DFT data sent to CMD',
        'medfx-adt': 'ADT data sent to MedFx',
        'medfx-dft': 'DFT data sent to MedFx',
        'opm-adt - sterling physicians medical': 'ADT data sent to OPM - Sterling Physicians Medical',
        'opm-dft - sterling physicians medical': 'DFT data sent to OPM - Sterling Physicians Medical',
        'opm-adt - physical medicine and rehab': 'ADT data sent to OPM - Physical Medicine and Rehab',
        'opm-dft - physical medicine and rehab': 'DFT data sent to OPM - Physical Medicine and Rehab',
        [BillingCompaniesConstants.CompMed.adt?.toLowerCase()]: 'ADT data sent to CompMed',
        [BillingCompaniesConstants.CompMed.dft?.toLowerCase()]: 'DFT data sent to CompMed',
        [BillingCompaniesConstants.Coronis.adt?.toLowerCase()]: 'ADT data sent to Coronis',
        [BillingCompaniesConstants.Coronis.dft?.toLowerCase()]: 'DFT data sent to Coronis',
    };

    if (audit.operation) {
        const operationsKeys = audit.operation.toLowerCase();
        const operated = operationMap[operationsKeys] || audit.operation;
        return `${operated} by ${audit.performed_by}`;
    }

}

  getAuditDate(i){
    return  `${moment(i.date).format('MM/DD/yyyy h:mm a')}` 
  }
  async getChargeAudit(){
    // this._toastr.info("Getting Info...")
    this.loading = true;
    let res:any = await this.billerDashboardService.getChargeAudit(this.charge_id).toPromise();
    if(res.status == 200){
      this.auditData = res.data
      if(this.auditData){
        for (let i = 0; i < this.auditData.operations.length; i++) {
          // const element = array[i];
          this.operations.unshift(this.auditData.operations[i]);
        } 
      }
    
    this.loading = false; 
    }
    if(this.operations && this.operations.length <= 0){
      this.hasData = false;
      this._toastr.success("No information availbale")
    }
  } 
}
